import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Implements the ABA routing number Mod 10 checksum rule.
export function isValidAbaRoutingNumber(input: string): boolean {
  const digits = input?.replace(/\D/g, "") ?? ""
  if (digits.length !== 9) return false

  const values = digits.split("").map((char) => char.charCodeAt(0) - 48)

  const sum =
    3 * (values[0] + values[3] + values[6]) +
    7 * (values[1] + values[4] + values[7]) +
    (values[2] + values[5] + values[8])

  return sum % 10 === 0
}
